import { isSVGElement } from "./is-svg-element.mjs";
function isSVGSVGElement(element) {
  return isSVGElement(element) && element.tagName === "svg";
}
export {
  isSVGSVGElement
};
